import { render, staticRenderFns } from "./AxZonePanel.vue?vue&type=template&id=036f6128&scoped=true"
import script from "./AxZonePanel.vue?vue&type=script&lang=ts"
export * from "./AxZonePanel.vue?vue&type=script&lang=ts"
import style0 from "./AxZonePanel.vue?vue&type=style&index=0&id=036f6128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f6128",
  null
  
)

export default component.exports